import ReleaseNotes from "./ReleaseNotes";
import Swagger from "./Swagger";
export default [
    { exact: true, path: "/docs/releases", component: ReleaseNotes },
    { exact: true, path: "/docs/api", component: Swagger }
];
